import Button from "components/atoms/Button";
import useTranslate from "hooks/useTranslate";
import { useTogglePopup } from "hooks/useTogglePopup";
import { STORAGE_MODAL_FORTUNE_WHEEL_SEEN } from "constants/variables";
import "./styles.sass";

const FortuneWheelModalContent: React.FC = () => {
  const t = useTranslate();

  const { closePopup } = useTogglePopup();

  const handleClick = () => {
    localStorage.setItem(STORAGE_MODAL_FORTUNE_WHEEL_SEEN, "true");
    closePopup();
  };

  return (
    <>
      <img
        src="https://diswdgcu9cfva.cloudfront.net/fortune-wheel/glory/popup.webp"
        width={500}
        height={297}
        alt="fortune_wheel_popup"
      />
      <div className="FortuneWheelModal__content">
        <div className="FortuneWheelModal__title">
          {t("wheel.fortune.popup.once.header")}
        </div>
        <div className="FortuneWheelModal__subtitle">
          {t("wheel.fortune.popup.once.desc")}
        </div>

        <div className="FortuneWheelModal__list">
          <div className="FortuneWheelModal__list_item">
            <div className="FortuneWheelModal__list_item_title">
              1. {t("wheel.fortune.popup.once.1.title")}
            </div>
            {t("wheel.fortune.popup.once.1.desc")}
          </div>
          <div className="FortuneWheelModal__list_item">
            <div className="FortuneWheelModal__list_item_title">
              2. {t("wheel.fortune.popup.once.2.title")}
            </div>
            {t("wheel.fortune.popup.once.2.desc")}
          </div>
          <div className="FortuneWheelModal__list_item">
            <div className="FortuneWheelModal__list_item_title">
              3. {t("wheel.fortune.popup.once.3.title")}
            </div>
            {t("wheel.fortune.popup.once.3.desc")}
          </div>
        </div>

        <Button
          variation="primary"
          label="wheel.fortune.popup.once.button"
          onClick={handleClick}
        />
      </div>
    </>
  );
};

export default FortuneWheelModalContent;
